<template>
  <span class="d-inline-flex">
    <v-tooltip v-for="agent in shortcuts" :key="agent.siteChatAgentId" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="globalbarelement rounded"
          :aria-label="agent.shortcutLabel || agent.displayName"
          :to="{ name: 'starfishAgent', params: { indexId: String(siteId) }, query: { source: agent.slug } }"
        >
          <v-icon size="28" class="material-symbols-outlined global-thin">{{ agent.iconValue }}</v-icon>
        </v-btn>
      </template>
      <span>{{ agent.shortcutLabel || agent.displayName }}</span>
    </v-tooltip>
  </span>
</template>

<script>
import historyApi from '@/mcp/services/conversationHistoryService';

export default {
  name: 'AgentNavShortcuts',
  props: { siteId: { type: [Number, String], required: true } },
  data: () => ({ agents: [], requestId: 0 }),
  computed: {
    shortcuts() { return this.agents.filter((agent) => agent.showInTopNav && agent.iconValue && agent.slug); },
  },
  watch: {
    siteId: {
      immediate: true,
      async handler(siteId) {
        const requestId = this.requestId + 1;
        this.requestId = requestId;
        this.agents = [];
        if (!siteId) return;
        try {
          const sources = await historyApi.fetchSources();
          if (requestId === this.requestId && String(sources.siteId) === String(siteId)) {
            this.agents = Array.isArray(sources.agents) ? sources.agents : [];
          }
        } catch (error) {
          // Navigation remains usable when chat configuration cannot be loaded.
          if (requestId === this.requestId) this.agents = [];
        }
      },
    },
  },
};
</script>
